"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var ModalContext_1 = require("./ModalContext");
var Modal = function (props) {
    var opened = props.opened, onChange = props.onChange, children = props.children;
    var modalValue = ModalContext_1.useInitializeContext({ opened: !!opened, onChange: onChange });
    return (react_1["default"].createElement(ModalContext_1.ModalContext.Provider, { value: modalValue }, children));
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map